import { useTLang } from 'intl/intl';

export function useSFWithoutSuggestionsModalLang() {
  return {
    title: useTLang({ id: 'substitutionFlow.006' }),
    paragraph: {
      first: useTLang({ id: 'substitutionFlow.017' }),
      second: useTLang({ id: 'substitutionFlow.018' }),
    },
    action: {
      secondaryBtn: {
        label: useTLang({ id: 'substitutionFlow.019' }),
      },
      primaryBtn: {
        label: useTLang({ id: 'substitutionFlow.020' }),
      },
    },
  };
}
